export default {
  NONE: 'none',
  OPEN_TABLE: 'opentable',
  RESY: 'resy',
  RESERVE: 'reserve',
  SEVEN_ROOMS: 'sevenrooms',
  YELP_RESERVATIONS: 'seatme',
};
